import messages from './cmsCopyUnitToLocale.json' with { type: 'json' };

export const cmsCopyUnitToLocaleFi: Readonly<typeof messages> = messages;
